import React from "react";
import { useTranslation } from "react-i18next";
import { isFeatureEnabled } from "../config/featureFlags";

const SiteFooter = () => {
  const { t } = useTranslation();
  // Sprint 47 — el link a /mantenimiento-piscina només es mostra quan el
  // feature flag està actiu. Per defecte OFF (oferta de mantenidors no
  // oberta públicament encara).
  const showMaintenance = isFeatureEnabled("maintenanceServiceVisible");

  return (
    <footer className="py-16 px-4 bg-slate-900" data-testid="footer">
      <div className="max-w-7xl mx-auto">
        {/* 4-Column Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          {/* Producto */}
          <div>
            <h3 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">
              {t("footer.col_product")}
            </h3>
            <ul className="space-y-3">
              <li>
                <a href="/ficha-tecnica" className="text-sm text-slate-400 hover:text-white transition-colors">
                  {t("header.technicalSheet", "Ficha Técnica")}
                </a>
              </li>
              <li>
                <a href="/pool-check" className="text-sm text-slate-400 hover:text-white transition-colors">
                  Check
                </a>
              </li>
              <li>
                <a href="/calculadoras" className="text-sm text-slate-400 hover:text-white transition-colors">
                  {t("header.calculators")}
                </a>
              </li>
            </ul>
          </div>

          {/* Profesionales */}
          <div>
            <h3 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">
              {t("footer.col_professionals")}
            </h3>
            <ul className="space-y-3">
              <li>
                <a href="/instaladores" className="text-sm text-slate-400 hover:text-white transition-colors">
                  {t("header.installers")}
                </a>
              </li>
              <li>
                <a href="/documentar-piscina" className="text-sm text-slate-400 hover:text-white transition-colors">
                  {t("footer.documentation")}
                </a>
              </li>
              {showMaintenance && (
                <li>
                  <a href="/mantenimiento-piscina" className="text-sm text-slate-400 hover:text-white transition-colors">
                    {t("header.maintenance")}
                  </a>
                </li>
              )}
              <li>
                <a href="/installer/login" className="text-sm text-slate-400 hover:text-white transition-colors">
                  {t("footer.installer_area")}
                </a>
              </li>
            </ul>
          </div>

          {/* Recursos */}
          <div>
            <h3 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">
              {t("footer.col_resources")}
            </h3>
            <ul className="space-y-3">
              <li>
                <a href="/initiative" className="text-sm text-slate-400 hover:text-white transition-colors">
                  {t("header.initiative")}
                </a>
              </li>
              <li>
                <a href="/piscina-legal" className="text-sm text-slate-400 hover:text-white transition-colors">
                  {t("footer.pool_legal")}
                </a>
              </li>
              <li>
                <a href="/comprar-casa-con-piscina" className="text-sm text-slate-400 hover:text-white transition-colors">
                  {t("footer.buying_house")}
                </a>
              </li>
              <li>
                <a href="/blog" className="text-sm text-slate-400 hover:text-white transition-colors">
                  Blog
                </a>
              </li>
              <li>
                <a href="https://legalizatupiscina.com" target="_blank" rel="noopener noreferrer" className="text-sm text-slate-400 hover:text-white transition-colors">
                  LegalizaTuPiscina.com
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">
              {t("footer.col_legal")}
            </h3>
            <ul className="space-y-3">
              <li>
                <a href="/legal" className="text-sm text-slate-400 hover:text-white transition-colors">
                  {t("footer.legalNotice")}
                </a>
              </li>
              <li>
                <a href="/legal#privacy-policy" className="text-sm text-slate-400 hover:text-white transition-colors">
                  {t("footer.privacy")}
                </a>
              </li>
              <li>
                <a href="/legal#terms-of-use" className="text-sm text-slate-400 hover:text-white transition-colors">
                  {t("footer.terms")}
                </a>
              </li>
              <li>
                <a href="mailto:info@legalizatupiscina.com" className="text-sm text-slate-400 hover:text-white transition-colors">
                  {t("footer.contact")}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom section */}
        <div className="pt-8 border-t border-slate-800">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
            <div>
              <a href="/initiative" className="text-white font-semibold text-lg hover:text-blue-400 transition-colors">
                © PoolLex.io Initiative
              </a>
              <p className="text-slate-500 text-sm mt-1">{t("tagline")}</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
